import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { MediaListItemMobile } from "../Molecules/MediaListItemMobile";
import { AlertResponse, MediaResponse, MediasResponse } from "../types/media";
import { TaskLinks } from "../types/taskLink";
import { MediumSkeletonListItem } from "../Molecules/skeletons/MediumSkeletonListItem";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";

interface MediasViewListMobileProps {
  mediasResponse: MediasResponse | undefined;
  taskLinks: TaskLinks;
  alerts: AlertResponse[] | undefined;
  loading?: boolean;
  filterValues?: FilterValue[];
}

export function MediasViewListMobile({
  mediasResponse,
  taskLinks,
  alerts,
  loading,
  filterValues,
}: MediasViewListMobileProps) {
  if (loading) {
    return (
      <FixaListView id="medias-list">
        <MediumSkeletonListItem key="medias-view-list-0" />
        <MediumSkeletonListItem key="medias-view-list-1" />
        <MediumSkeletonListItem key="medias-view-list-2" />
        <MediumSkeletonListItem key="medias-view-list-3" />
      </FixaListView>
    );
  } else {
    return (
      <FixaListView id="medias-list">
        {mediasResponse?.medias &&
          mediasResponse?.medias.map((media) => (
            <MediaListItemMobile
              key={media.id}
              mediaResponse={
                {
                  media: media,
                  children: mediasResponse?.children ?? [],
                } as MediaResponse
              }
              taskLinks={taskLinks}
              alerts={alerts || []}
              filterValues={filterValues}
            />
          ))}
      </FixaListView>
    );
  }
}
